//# sourceMappingURL=loading.mjs.map
/// <reference types="./loading.d.mts" />
import { CustomType as $CustomType } from "../../gleam.mjs";

export class Loading extends $CustomType {
  constructor(content_library, projects, proposals) {
    super();
    this.content_library = content_library;
    this.projects = projects;
    this.proposals = proposals;
  }
}
export const Loading$Loading = (content_library, projects, proposals) =>
  new Loading(content_library, projects, proposals);
export const Loading$isLoading = (value) => value instanceof Loading;
export const Loading$Loading$content_library = (value) => value.content_library;
export const Loading$Loading$0 = (value) => value.content_library;
export const Loading$Loading$projects = (value) => value.projects;
export const Loading$Loading$1 = (value) => value.projects;
export const Loading$Loading$proposals = (value) => value.proposals;
export const Loading$Loading$2 = (value) => value.proposals;

export function new$() {
  return new Loading(true, true, true);
}

export function content_library(loading) {
  return new Loading(false, loading.projects, loading.proposals);
}

export function projects(loading) {
  return new Loading(loading.content_library, false, loading.proposals);
}

export function proposals(loading) {
  return new Loading(loading.content_library, loading.projects, false);
}
